<template>
  <div class="dadata-address">
    <vue-dadata
        v-model="address"
        :token="token"
        v-model:suggestion="suggestion"
        placeholder="Введите адрес"
        from-bound="area"
    />
  </div>
</template>

<script>
import { VueDadata } from 'vue-dadata';
import 'vue-dadata/dist/style.css';
import {addressErrorMixin} from "../../mixins/addressErrorMixin";

export default {
  name: 'TheCartDaDataAddress',
  mixins: [addressErrorMixin],
  components: {
    VueDadata,
  },
  setup() {
    return {
      token: 'e708eca2a8f173bab2e7b870ca8f4199a5988340',
    };
  },
  computed: {
    suggestion: {
      get() {
        return null;
      },
      set(value) {
        if (value.data.qc_geo === '0') {
          this.$store.commit('order/setIsAddressOk', true);
          this.$store.commit('order/setDaDataResult', value.data);
          this.setAddressError(null);
        } else {
          this.$store.commit('order/setIsAddressOk', false);
          this.setAddressError('Кажется, адрес не полный или некорректный. Попробуйте еще раз')
        }
      }
    },
    address: {
      get () {
        return this.$store.state.order.address
      },
      set (value) {
        this.$store.commit('order/setAddress', value);
        this.$store.commit('order/setIsAddressOk', false);
      }
    },
    errors: {
      get () {
        return this.$store.state.order.errors;
      },
    },
  },
};
</script>

<style lang="scss">
  .dadata-address{
    margin-top: 40px;

    .vue-dadata__input:focus{
      box-shadow: unset;
    }

    .vue-dadata__suggestions{
      -webkit-box-shadow: -1px 4px 26px 0px rgba(34, 60, 80, 0.2);
      -moz-box-shadow: -1px 4px 26px 0px rgba(34, 60, 80, 0.2);
      box-shadow: -1px 4px 26px 0px rgba(34, 60, 80, 0.2);
    }
    .vue-dadata__suggestions-item{
      &:hover{
        background: var(--background-color);
      }
    }
    .vue-dadata__suggestion-item-text_highlight{
      background: var(--yellow-icon);
    }
  }
</style>